import { dateFormatter } from 'core/utils/commonUtils';
import { getOrderActionName } from 'core/utils/orderUtils';
import { OrderActionEnum } from 'models/enums/orderActionEnum';
import type { EventExtendedProps } from './CalendarPage';
import type { OrderStateEnum } from 'models/enums/orderStateEnum';
import type { OrderActionsLog } from 'models/orderActionsLog';

export const getActionColor = (action: OrderActionEnum): string => {
  switch (action) {
    case OrderActionEnum.Monolith:
      return '#b7a72a';

    case OrderActionEnum.Measurement:
      return '#320fb2';

    case OrderActionEnum.Installation:
      return '#33bf09';

    default:
      return '#facade';
  }
};

export const getActionUserRoleName = (action: OrderActionEnum): string => {
  const roles: Record<number, string> = {
    [OrderActionEnum.Measurement]: 'Замерщик',
    [OrderActionEnum.Monolith]: 'Ответственный',
    [OrderActionEnum.Installation]: 'Установщик',
  };

  return roles[action] ?? 'Ответственный';
};

export const getOrderPath = (orderState: OrderStateEnum, orderId: number): string => {
  const paths = ['/requests', '/orders', '/archive'] as const;
  return `${paths[orderState]}/${orderId}`;
};

export const createEventProps = (event: OrderActionsLog): EventExtendedProps => ({
  eventName: `Заказ ${event.order.number}`,
  dateCreated: dateFormatter.format(event.dateCreate),
  action: getOrderActionName(event.action),
  actionCode: event.action,
  dateAction: event.dateAction ? dateFormatter.format(event.dateAction) : '',
  orderId: event.order.id,
  orderNumber: event.order.number,
  orderState: event.order.state,
  orderDateCreated: dateFormatter.format(event.order.dateCreate),
  orderAddress: event.order.address,
  orderGeolocation: event.order.geolocation ?? { latitude: 0, longitude: 0 },
  clientId: event.order.client.id,
  clientName: event.order.client.fullName,
  clientPhone: event.order.client.phone,
  userId: event.user?.id,
  userFullName: event.user?.fullName,
});

export const compareDays = (date1: Date, date2: Date): boolean =>
  date1.getDate() === date2.getDate() &&
  date1.getMonth() === date2.getMonth() &&
  date1.getFullYear() === date2.getFullYear();

export const checkToday = (date: Date): boolean => {
  const today = new Date();
  return compareDays(date, today);
};

export const checkWeekend = (date: Date): boolean => [0, 6].includes(date.getDay());
